<template>
    <span class="ceo-change-logo" v-html="logo"></span>
</template>

<script>
import logo from '@/images/icon-ceo-change.svg?embed'

export default {
    name: 'CeoChangeLogo',
    data() {
        return { logo }
    },
}
</script>

<style>
.ceo-change-logo {
    display: inline-block;
    line-height: 1;
    vertical-align: bottom;

    svg {
        display: block;
    }

    .icon {
        fill: #626166;
    }

    &.verified .icon {
        fill: #3d9e3e;
    }

    &.button-icon {
        margin-right: 8px;
        vertical-align: -2px;

        .icon {
            fill: white;
        }
    }

    &.lg {
        line-height: 26px;

        &.inline {
            margin-left: 8px;
            position: relative;

            svg {
                position: relative;
                top: -4px;
            }
        }

        svg {
            width: 26px;
            height: 26px;
        }
    }

    &.md {
        &.inline {
            margin-left: 6px;
        }

        svg {
            width: 20px;
            height: 20px;
        }
    }

    &.sm {
        &.inline {
            margin-left: 6px;
        }

        svg {
            width: 16px;
            height: 16px;
        }
    }

    &.xs {
        &.inline {
            margin-left: 6px;
        }

        &.inline-text {
            margin-left: 2px;
            vertical-align: -2px;
        }

        svg {
            width: 14px;
            height: 14px;
        }
    }
}

.navigation-button {
    .ceo-change-logo {
        svg {
            height: 24px;
            position: relative;
            top: 6px;
        }
    }
}

li.active {
    .ceo-change-logo .icon {
        fill: white;
    }
}
</style>
